import tableListTalkingPoint from 'View/brief-live/const/tableListTalkingPoint';
import tableListGiveaway from 'View/brief-live/const/tableListGiveaway';

const getTableList = ({ selectedTab, t }) => {
  switch (selectedTab) {
    case 'talkingPoint':
      return tableListTalkingPoint({ t });

    case 'giveaway':
      return tableListGiveaway({ t });

    default:
      return tableListTalkingPoint({ t });
  }
};

export default getTableList;
